import React from "react";

const getRowKey = (row, index) => row?.id || `agenda-row-${index}`;

const MeetingAgendaTable = ({ rows, getLocalizedField }) => {
  const headerRows = rows.filter((row) => row.header);
  const bodyRows = rows.filter((row) => !row.header);
  const columnHeader = headerRows[headerRows.length - 1] || null;
  const timeLabel = columnHeader ? getLocalizedField(columnHeader, "col1") : "";
  const hallALabel = columnHeader ? getLocalizedField(columnHeader, "col2") : "";
  const hallBLabel = columnHeader ? getLocalizedField(columnHeader, "col3") : "";
  const hasHallB = bodyRows.some((row) => getLocalizedField(row, "col3").trim());

  return (
    <div className="agenda-schedule">
      <div className="agenda-schedule__desktop">
        <table className="agenda-table">
          {columnHeader ? (
            <thead>
              <tr>
                <th scope="col" className="agenda-table__time-col">
                  {timeLabel || "\u00a0"}
                </th>
                <th scope="col">{hallALabel || "\u00a0"}</th>
                {hasHallB ? <th scope="col">{hallBLabel || "\u00a0"}</th> : null}
              </tr>
            </thead>
          ) : null}
          <tbody>
            {bodyRows.map((row, index) => {
              const hallA = getLocalizedField(row, "col2");
              const hallB = getLocalizedField(row, "col3");

              return (
                <tr key={getRowKey(row, index)}>
                  <th scope="row" className="agenda-table__time-col">
                    <span className="agenda-table__time-pill">{row.col1}</span>
                  </th>
                  <td className="agenda-table__hall-a">{hallA || "\u00a0"}</td>
                  {hasHallB ? (
                    <td className="agenda-table__hall-b">{hallB || "\u00a0"}</td>
                  ) : null}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="agenda-schedule__mobile">
        {bodyRows.map((row, index) => {
          const hallA = getLocalizedField(row, "col2");
          const hallB = getLocalizedField(row, "col3");

          return (
            <article className="agenda-card" key={getRowKey(row, index)}>
              <div className="agenda-card__time">{row.col1}</div>
              <div className="agenda-card__tracks">
                {hallA ? (
                  <div className="agenda-card__track agenda-card__track--a">
                    {hallALabel ? <span className="agenda-card__label">{hallALabel}</span> : null}
                    <p>{hallA}</p>
                  </div>
                ) : null}
                {hallB ? (
                  <div className="agenda-card__track agenda-card__track--b">
                    {hallBLabel ? <span className="agenda-card__label">{hallBLabel}</span> : null}
                    <p>{hallB}</p>
                  </div>
                ) : null}
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
};

export default MeetingAgendaTable;
